import MuiDialog from '@mui/material/Dialog'
import Shadow from '../../atoms/shadow'
import Button from '../button'
import IconClose from '../../atoms/icons/x-icon'
import { useTheme } from '@mui/system'
import useMediaQuery from '@mui/material/useMediaQuery'
import { node, arrayOf, shape, bool } from 'prop-types'

const Dialog = ({ variant, className, buttonCloseProps, showButtonClose, children, onClose, ...props }) => {
	const theme = useTheme()
	const smUp = useMediaQuery(theme.breakpoints.up('sm'))

	return (
		<MuiDialog
			elevation={6}
			PaperComponent={Shadow}
			maxWidth={smUp ? variant : 'sm'}
			onClose={onClose}
			className={className}
			{...props}
		>
			{showButtonClose && onClose && (
				<Button
					variant="icon"
					Icon={IconClose}
					iconProps={{ fontSize: 'medium' }}
					className="iconClose"
					color="black"
					{...buttonCloseProps}
					onClick={(...args) => {
						onClose(...args, 'buttonCloseClick')
						if (buttonCloseProps?.onClick) buttonCloseProps.onClick(...args, 'buttonCloseClick')
					}}
				/>
			)}
			{children}
		</MuiDialog>
	)
}

Dialog.defaultProps = {
	...MuiDialog.defaultProps,
	actions: [],
}

Dialog.propTypes = {
	...MuiDialog.propTypes,
	/**
	 *  If true, the component is shown.
	 */
	open: bool.isRequired,
	/**
	 * Dialog children, usually the included sub-components.
	 */
	children: node,
	/**
	 * Props for Button Close component (view Button propTypes)
	 */
	buttonCloseProps: shape({ ...Button.propTypes, show: bool }),
	/**
	 * Array of buttons (view Button propTypes)
	 */
	actions: arrayOf(shape({ ...Button.propTypes })),
	/**
	 * Variant of Dialog: ex. sm, md, lg
	 */
	variant: MuiDialog.propTypes?.maxWidth,
	/**
	 * Show or hide button close
	 */
	showButtonClose: bool,
}

export default Dialog
